import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import { Heading, Paragraph } from 'components';
import './YouTubePlayer.scss';

class YouTubePlayer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVideoStarted: false,
    };
  }

  render() {
    const { isVideoStarted } = this.state;
    const {
      containerClass,
      playerClass,
      src,
      width,
      height,
      description,
      title,
      titleColor,
      ...other
    } = this.props;

    return typeof window === 'undefined' ? null : (
      <div
        className={`youtube-player__container ${containerClass} ${
          isVideoStarted ? '' : 'overlayed'
        }`}
      >
        {title && !isVideoStarted && (
          <div className={'youtube-player__content'}>
            <Heading
              type={3}
              size={'medium'}
              color={titleColor}
              additionalClass={'youtube-player__title'}
            >
              {title}
            </Heading>
            <Paragraph
              size={'small'}
              color={titleColor}
              additionalClass={'youtube-player__description'}
            >
              {description}
            </Paragraph>
          </div>
        )}
        <ReactPlayer
          className={`youtube-player ${playerClass}`}
          url={src}
          width={width}
          height={height}
          controls
          config={{
            youtube: {
              playerVars: { showinfo: 0, modestbranding: 0 },
            },
          }}
          onStart={() => this.setState({ isVideoStarted: true })}
          {...other}
        />
      </div>
    );
  }
}

YouTubePlayer.defaultProps = {
  title: '',
  description: '',
  titleColor: 'white',
  containerClass: '',
  playerClass: '',
  width: '100%',
  height: '100%',
};

YouTubePlayer.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  titleColor: PropTypes.string,
  containerClass: PropTypes.string,
  playerClass: PropTypes.string,
  src: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default YouTubePlayer;
